import { Injectable } from '@angular/core';
import { StrapiSingleEntityApiService } from '@core/data-access';
import { filter, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CategoriesMenuApiService extends StrapiSingleEntityApiService<{ value: string }> {
  constructor() {
    super('root-node-id');
  }

  getRootNodeId(): Observable<string> {
    return this.getEntity().pipe(
      map(({ value }) => value),
      filter(Boolean),
    );
  }
}
